import { Component, ViewContainerRef, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { APP_READY } from '../utils/utils';
import { DataService } from '../services/data.service';

@Component({
    selector: 'my-app',
    template: require('./app.component.html'),
    styles: [require('./app.component.css')]
})
export class AppComponent implements OnInit, OnDestroy {
    private isAppReady: boolean = false;
    private _dataStoreObservable: EventEmitter<any>;
    constructor(private dataservice: DataService, private viewContainerRef: ViewContainerRef) { }
    
    ngOnInit() {
       // console.log("App component called");
       //this._dataStoreObservable = this.dataStore.getObservableFor(APP_READY).subscribe(value => this.isAppReady = value);

        //this.isAppReady = this.dataStore.getData(APP_READY);
    }

    ngOnDestroy() {
        if (this._dataStoreObservable)
            this._dataStoreObservable.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/boot/app.component.ts